<template>
    <v-col
        :cols="questionWidth || DEFAULT_QUESTION_WIDTH"
        :class="`${isSubItem ? 'numbered-item-subitem' : ''} ${required && formatText.trim() ? 'required' : ''}`"
    >
        <template v-if="isSubItem">
            <v-label
                :class="`${isRequired ? ' required' : ''}`"
            ><span v-html="formatText"></span></v-label>
        </template>
        <template v-else>
            <span
                :class="`numbered-item-label primary-item-label ${isRequired ? ' required' : ''}`"
            >{{ count ? count + '. ' : '' }} <span v-html="formatText"></span></span>
        </template>

        <v-tooltip
            v-if="message"
            top
            max-width="620"
            dark
        >
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-information</v-icon>
            </template>
            <div v-html="message"></div>
        </v-tooltip>
    </v-col>
</template>

<script>
    import { DEFAULT_QUESTION_WIDTH } from '../constants';
    import { formatText } from '../utilities';

    export default {
        name: 'NumberedItem',
        
        props: {
            count: Number,
            data: Object,
            text: String,
            isSubItem: Boolean,
            message: String,
            questionWidth: Number,
            required: Boolean
        },

        data: () => ({
            DEFAULT_QUESTION_WIDTH
        }),
        
        computed: {
            formatText: function () {
                // If a text field contains ${value} - replace the key with the value from the model data
                return formatText(this.text, this.data);
            },
            isRequired: function () {
                return this.required && this.formatText.trim();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .numbered-item-subitem {
        padding-left: 80px;
    }

    .primary-item-label {
        font-weight: bold;
    }

    .numbered-item-label.required::after {
        content: "*";
        color: #ff0000;
        margin-left: 0.3em;
    }

    label.required::after {
        content: "*";
        color: #ff0000;
        margin-left: 0.3em;
    }
    .question_list li { 
        margin: .8em 0 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/numbered-item.vue